export default "__VITE_ASSET__xzlwe03V__"